import { combineReducers } from "redux-immutable";

import { Action } from "common/types";

import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import actionTypes from "../action-types";
import { schoolInfoCrudStateConfig } from "../consts";
import SchoolInfo, { SchoolInfoType } from "../models/SchoolInfo";
import SchoolInfoState from "../models/SchoolInfoState";

export function schoolInfoReducer(
  schoolInfo: SchoolInfo | null = new SchoolInfo(),
  action: Action<SchoolInfoType>
) {
  switch (action.type) {
    case actionTypes.RECEIVE_SCHOOL_INFO:
      const school = action.payload;
      return school ? new SchoolInfo(action.payload) : null;
    default:
      return schoolInfo;
  }
}

export const metaReducer = makeCrudStateReducer(schoolInfoCrudStateConfig);

const schoolInfoStateReducer = combineReducers(
  {
    schoolInfo: schoolInfoReducer,
    meta: metaReducer
  },
  () => new SchoolInfoState() as any
);

export default schoolInfoStateReducer;
